import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { getSelectedCookies, getManagerDependingVariables, deleteCookiesLocally, deleteCookiesServer } from ".";
import { putHtmlCodeToDom } from "..";
import { getOtherOptionsFromWindow } from "../../utils";
import { OPT_OUT_EVENT } from "../../types";
/**
 * Opt-in to a set of cookies for a given data manager like GTM / MTM.
 */

function applyOptOut(_x, _x2) {
  return _applyOptOut.apply(this, arguments);
}

function _applyOptOut() {
  _applyOptOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, isManagerOptOut) {
    var _getSelectedCookies, isManagerActive, iterateCookies, _getOtherOptionsFromW, setCookiesViaManager, _getManagerDependingV, useVariableNamePascal, foundOptOutToDelete;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _getSelectedCookies = getSelectedCookies(type), isManagerActive = _getSelectedCookies.isManagerActive, iterateCookies = _getSelectedCookies.iterateCookies;
            _getOtherOptionsFromW = getOtherOptionsFromWindow(), setCookiesViaManager = _getOtherOptionsFromW.setCookiesViaManager;
            _getManagerDependingV = getManagerDependingVariables(isManagerActive, setCookiesViaManager), useVariableNamePascal = _getManagerDependingV.useVariableNamePascal; // Handle opt-outs sequentially

            foundOptOutToDelete = [];
            _context2.next = 6;
            return iterateCookies( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(group, cookie, isOptIn) {
                var id, codeDynamics, codeOptOut, codeOptOutDelete, noTechnicalDefinitions, technicalDefinitions, rest, isOnlyWhenNoConsentToManager;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        id = cookie.id, codeDynamics = cookie.codeDynamics, codeOptOut = cookie.codeOptOut, codeOptOutDelete = cookie.codeOptOutDelete, noTechnicalDefinitions = cookie.noTechnicalDefinitions, technicalDefinitions = cookie.technicalDefinitions, rest = _objectWithoutProperties(cookie, ["id", "codeDynamics", "codeOptOut", "codeOptOutDelete", "noTechnicalDefinitions", "technicalDefinitions"]);

                        if (!isOptIn) {
                          // Check if the script should explicitly only be loaded if no consent is given to the manager
                          isOnlyWhenNoConsentToManager = isManagerActive && rest["codeOptInNo".concat(useVariableNamePascal)];

                          if (isOnlyWhenNoConsentToManager && !isManagerOptOut || !isOnlyWhenNoConsentToManager) {
                            putHtmlCodeToDom(codeOptOut, codeDynamics);
                          }

                          if (codeOptOutDelete && !noTechnicalDefinitions) {
                            deleteCookiesLocally(technicalDefinitions, codeDynamics); // Mark deletable server-side cookies

                            if (technicalDefinitions.some(function (_ref2) {
                              var type = _ref2.type;
                              return type === "http";
                            })) {
                              foundOptOutToDelete.push(id);
                            }
                          }

                          document.dispatchEvent(new CustomEvent(OPT_OUT_EVENT, {
                            detail: {
                              group: group,
                              cookie: cookie
                            }
                          }));
                        }

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3, _x4, _x5) {
                return _ref.apply(this, arguments);
              };
            }());

          case 6:
            // Handle cookie deletion which needs to be done server-side (e. g. HTTP cookies)
            foundOptOutToDelete.length && setTimeout(function () {
              return deleteCookiesServer(foundOptOutToDelete);
            }, 0);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _applyOptOut.apply(this, arguments);
}

export { applyOptOut };